import script from "./ReportCriterionMultiselectAutocomplete.vue?vue&type=script&setup=true&lang=js"
export * from "./ReportCriterionMultiselectAutocomplete.vue?vue&type=script&setup=true&lang=js"

import "./ReportCriterionMultiselectAutocomplete.vue?vue&type=style&index=0&id=c2fd9b7e&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Utilizador\\Desktop\\projetos\\owlpharma-hrm\\src\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c2fd9b7e"]])

export default __exports__